import React from "react";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// hook
import { useStyles } from "../hooks/table.useStyles";
// UI
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TableSortLabel from "@material-ui/core/TableSortLabel";

interface HeadCell {
  id: string;
  label: string;
}

const headCells: HeadCell[] = [
  { id: "received_date", label: "table_receive_date" },
  { id: "elapsed_time_number", label: "table_elapsed_time" },
  { id: "job_no", label: "table_job_no" },
  { id: "statusName", label: "table_status" },
  { id: "model_no", label: "table_model" },
  { id: "serial_no", label: "table_serial_no" },
  { id: "customer_po_no", label: "table_customer_po_no" },
  { id: "customer_no", label: "table_customer_no" },
  { id: "customer_name", label: "table_customer_name" },
  { id: "postal_cd", label: "table_postcode" },
  { id: "address_1", label: "table_city" },
  { id: "address", label: "table_address" },
  { id: "quote_sent_date", label: "table_quote_sent_date" },
  { id: "quote_remind_date", label: "table_quote_remind_date" },
  { id: "quoteResultName", label: "table_quote_result" },
  { id: "location_no", label: "table_location_no" },
  { id: "name", label: "table_technician" },
];

export const SearchResultTableThead = (props: any) => {
  const classes = useStyles();
  const { order, orderBy, onRequestSort } = props;
  const { t } = useLocale({ defaultPath: "modules.components.jobs" });

  const createSortHandler = (property: any) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className={classes.thead}>
      <TableRow className={classes.tableRowHeader}>
        <TableCell padding="checkbox">
          {props.userPermisssionInfo.job_allocation_authFlg?(
          <Checkbox
            indeterminate={props.indeterminate}
            checked={props.allChecked}
            onChange={props.onSelectAllClick}
          />
          ):(
            <Checkbox
            disabled={!props.userPermisssionInfo.job_allocation_authFlg}
          />
          )}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy.indexOf(headCell.id) > -1 ? order : false}
          >
            <TableSortLabel
              active={orderBy.indexOf(headCell.id) > -1}
              direction={orderBy.indexOf(headCell.id) > -1 ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {t(headCell.label)}
              {orderBy.indexOf(headCell.id) > -1 ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
